/* eslint-disable class-methods-use-this */
import axios from "axios";

import {API_USER_URL, BASE_URL, COMMON_HEADER_CONFIG} from "../config";

class AccountService {
  forgotPassword = (email) =>
    new Promise((resolve, reject) => {
      const config = {
        headers: {
          ...COMMON_HEADER_CONFIG
        },
        method: "post",
        url: `${BASE_URL}/api/forgotpassword`,
        data: {
          email
        }
      };
      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  resetPassword = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        headers: {
          ...COMMON_HEADER_CONFIG
        },
        method: "post",
        url: `${API_USER_URL}/forgotpassword/update`,
        data
      };
      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateAccount = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "put",
        url: `${API_USER_URL}/profile/update`,
        data,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `${localStorage.getItem("accessToken")}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const accountService = new AccountService();

export default accountService;
